module.exports = __webpack_public_path__ + "img/2011.10.67480e31.png";